import { parseHtml } from "@/utils/common";
import Image from "next/image";
interface AccordionProps {
  data: {
    Title?: string;
    "key-points"?: {
      id: number;
      title: string;
    }[];
    Card?: {
      id: number;
      title: string;
      text: string;
      tags: {
        id: number;
        Title: string;
      }[];
    }[];
  };
}

const Strategies: React.FC<AccordionProps> = ({ data }) => {
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[83px] ">
      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full">
            <div className="xl:col-span-4 md:col-span-4 xl:sticky top-[140px]">
              <h2 className="text-heading-3 font-bold text-primary-text mb-[24px] text-left  max-w-[1230px] mx-auto">
                {data?.Title ?? ""}
              </h2>

              <div>
                {data?.["key-points"]?.map((item: any, index: number) => (
                  <p
                    key={index}
                    className="flex text-subtitle-2 font-normal text-primary-text mb-4 space-x-2 text-start"
                  >
                    <span className="ml-2">
                      <Image
                        height={20}
                        width={20}
                        quality={100}
                        src="/images/verify.svg"
                        alt=""
                        className="w-[30px] h-[20px] object-contain"
                      />
                    </span>
                    <span>{item?.title ?? ""}</span>
                  </p>
                ))}
              </div>
            </div>

            <div className="xl:col-span-8 md:col-span-8">
              {data?.Card?.map((item: any, index: number) => (
                <div
                  key={"faq" + index + "-1"}
                  className={`p-[32px] hover:brightness-110 bg-top-right bg-no-repeat border border-${(index + 1) % 2 !== 0 ? "border" : "green-100"} text-left mb-[30px]`}
                  style={{
                    backgroundImage:
                      (index + 1) % 2 !== 0
                        ? "url('/images/tech/bg-image-1.png')"
                        : "url('/images/tech/bg-image.png')",
                  }}
                >
                  <h3 className="text-heading-5 text-secondary-text mb-4 font-bold">
                    {item?.title ?? ""}
                  </h3>
                  <p className="text-left text-subtitle-2 text-secondary-text">
                    {item?.text ? parseHtml(item?.text) : ""}
                  </p>
                  <div className="flex gap-3 flex-wrap">
                    {item?.tags?.map((item: any, i: number) => (
                      <div
                        key={i}
                        className={`text-primary-text font-regular text-subtitle-4 px-3 pt-2.5 pb-1.5 border border-${(index + 1) % 2 !== 0 ? "border" : "green-100"}`}
                      >
                        {item?.Title ?? ""}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strategies;
